export default "__VITE_ASSET__BCmovO6Q__";